var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#494b74",
    fillRule: "evenodd",
    d: "M5.3,3.913A2.5,2.5,0,0,1,7.235,3h5.833A2.5,2.5,0,0,1,15,3.912l.053.028,3.924,2.266a.833.833,0,0,1,.305,1.138L17.9,9.735a.833.833,0,0,1-1.138.305l-1.195-.69v6.983a.833.833,0,0,1-.833.833H5.568a.833.833,0,0,1-.833-.833V9.35l-1.194.689A.833.833,0,0,1,2.4,9.735L1.023,7.344a.833.833,0,0,1,.305-1.138L5.252,3.94Z",
    transform: "translate(-0.152 -0.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#494b74",
    fillRule: "evenodd",
    d: "M9.739,3.186l-.491.737a.417.417,0,0,0,.1.564L10.7,5.5l-.8,5.627a.417.417,0,0,0,.118.354l1.225,1.225a.417.417,0,0,0,.589,0l1.225-1.225a.417.417,0,0,0,.118-.354l-.8-5.627,1.351-1.014a.417.417,0,0,0,.1-.564l-.491-.737A.417.417,0,0,0,12.973,3H10.086A.417.417,0,0,0,9.739,3.186Z",
    transform: "translate(-1.53 -0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b64ee9dcbc2d81bd088f245591514c7b.svg";
export { ForwardRef as ReactComponent };